/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';

import { object, number, func } from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import MobileRecipientCard from './MobileRecipientCard';

const useStyles = makeStyles(() => ({
    card: {
        '& .mbp-account-MuiPaper-root': {
            marginBottom: '16px',
            borderRadius: '8px',
            boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.10)',
            fontFamily: 'Lato',
        },
    },
}));

const MobileRecipientBookList = ({ recipientState, classes: globalClasses, visibleRecipientsCount, lazyLoadContacts }) => {
    const classes = useStyles();
    let lastSelfContactCardId = '';

    // have the self contact cards on the top of the list
    const sortedAddresses = ((addresses) => {
        if (addresses?.length) {
            addresses = addresses?.map((address) => {
                if (address.relationship === "") delete address.relationship;
                return address;
            });

            const selfContactCards = addresses?.filter((address) => +address.relationship === 0);
            const otherContactCards = addresses.filter((address) => +address.relationship !== 0);

            lastSelfContactCardId = (selfContactCards?.length && otherContactCards?.length) ? selfContactCards[selfContactCards?.length - 1]?.rcpId : '';
            addresses = [
                ...selfContactCards,
                ...otherContactCards
            ];
        }
        return addresses;
    })(recipientState?.addressBookResponse?.addressList);

    // there can be sorting logic here separating out the recipients from the recipients list
    return (
        <div className={classes.card}>
            {
                sortedAddresses?.length > 0 ? (
                    sortedAddresses?.slice(0, visibleRecipientsCount).map((recipient, index) => (
                        <MobileRecipientCard
                            recipient={recipient}
                            globalClasses={globalClasses}
                            lazyLoadContacts={lazyLoadContacts}
                            isLastSelfContactCardId={lastSelfContactCardId === recipient?.rcpId}
                            isLastVisibleContact={lazyLoadContacts ? visibleRecipientsCount === index + 1 : false}
                        />
                    ))
                ) : <p style={{ textAlign: 'center' }}>No Contacts Found</p>
            }
        </div>
    );
};

MobileRecipientBookList.propTypes = {
    classes: object.isRequired,
    recipientState: object.isRequired,
    lazyLoadContacts: func.isRequired,
    visibleRecipientsCount: number.isRequired,
};

export default MobileRecipientBookList;
